import gql from 'graphql-tag';

export const SORT_TAG_IN_PROJECT = gql`
  mutation sortTags($tagId: Int!, $sort: Int!) {
    tagMutation {
      sortTagInProject(sort: $sort, tagId: $tagId)
    }
  }
`;
